import { render, staticRenderFns } from "./mesVentesPart.vue?vue&type=template&id=06624d1a&"
import script from "./mesVentesPart.vue?vue&type=script&lang=js&"
export * from "./mesVentesPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports